import { ICustomerSmsHistoryHook } from '@models';
import { useStore } from '@stores';
import { useEffect, useState } from 'react';

interface IProps {
  customerId: string | undefined;
  vin?: string;
  registrationNumber?: string;
}

export const useCustomerSmsHistory = ({
  customerId,
  vin,
  registrationNumber,
}: IProps): ICustomerSmsHistoryHook => {
  const { customerStore } = useStore();
  const {
    smsHistory,
    smsHistoryTotalCount,
    smsHistoryCurrentPage,
    smsHistoryMaxResultCount,
    smsHistorySkipCount,
    smsHistoryLoading,
  } = customerStore;

  const [sorting, setSorting] = useState<string | undefined>();

  useEffect(() => {
    customerId &&
      customerStore.getSmsHistory({
        customerId,
        vin,
        registrationNumber,
        maxResultCount: smsHistoryMaxResultCount,
        skipCount: smsHistorySkipCount,
        sorting,
      });
  }, [
    customerStore,
    customerId,
    vin,
    registrationNumber,
    smsHistoryMaxResultCount,
    smsHistorySkipCount,
    sorting,
  ]);

  useEffect(() => {
    return () => customerStore.resetSmsHistory();
  }, [customerStore]);

  const handlePageChange = (pagination: any) => {
    customerStore.setSmsHistoryMaxResultCount(pagination.pageSize);
    customerStore.setSmsHistorySkipCount((pagination.current - 1) * pagination.pageSize);
    customerStore.setSmsHistoryCurrentPage(pagination.current);
  };

  const handleSortChange = (value?: string) => {
    setSorting(value);
    customerStore.setSmsHistorySkipCount(0);
    customerStore.setSmsHistoryCurrentPage(1);
  };

  return {
    loading: smsHistoryLoading,
    dataSource: Array.from(smsHistory.values()),
    totalCount: smsHistoryTotalCount,
    currentPage: smsHistoryCurrentPage,
    maxResultCount: smsHistoryMaxResultCount,
    handlePageChange,
    handleSortChange,
    sorting,
  };
};
